export const MODALITIES = [
  'CR',
  'DX',
  'DR',
  'CT',
  'MR',
  'MG',
  'US',
  'ES',
  'PT',
  'ST',
  'XA',
  'SR',
  'SM',
  'OT',
  'ESTMH',
  'IVF',
  'BMD',
  'TVSH',
];

export const FILTER_TYPE = {
  INSTITUTION: 'institution_ids',
  PROCEDURE_GROUP: 'procedure_groups',
  SCHEDULED_DATE: 'scheduled_date',
  VISIT_ID: 'visit_id',
  PATIENT_NAME: 'patient_name',
  ORDER_GROUP: 'order_group',
  STATUS: 'status',
  PATIENT_ID: 'patient_id',
  STUDY_DESC: 'study_desc',
  MODALITIES: 'modalities',
};

export const INITIAL_FILTERS = {};
